import { hocSinhSelectionActions } from './hocSinhSelectionActions';
export const hocSinhActionsWrapper = {
    hocSinhSelection: hocSinhSelectionActions
}